import React, { ReactNode } from 'react'
import { Box, Flex } from 'theme-ui'

interface ReportLineProps {
  icon?: ReactNode
  children?: ReactNode
  name: string
}

export default function ReportLine({ icon, children, name }: ReportLineProps) {
  return (
    <Flex mb={3} sx={{ alignItems: 'center' }}>
      <Box
        sx={{
          flex: '1',
          alignSelf: 'center',
          maxWidth: '45px',
          display: ['none', 'block'],
        }}
      >
        {icon}
      </Box>

      <Box sx={{ flex: '17', alignSelf: 'center' }}>{children}</Box>
    </Flex>
  )
}
